// https://css-tricks.com/how-i-put-the-scroll-percentage-in-the-browser-title-bar/
const style = document.createElement('style');
style.innerHTML = `
.pb {
    position: fixed;
    top: 0;
    height: 5px;
    width: 100%;
    background: #ddd;
}
.pc {
    position: fixed;
    top: 20%;
    left: 30px;
}
.bg {
    border-radius: 50%;
    width: 60px;
    height: 60px;
    background: #ddd;
    margin-bottom: 20px;
}
.ol {
    border-radius: 50%;
    width: 44px;
    height: 44px;
    background: #fff;
    position: absolute;
    margin-top: 8px;
    margin-left: 8px;
}
`;

const pb = document.createElement("div");
pb.classList.add("pb");

const ol = document.createElement("div");
ol.classList.add("ol");

const bg = document.createElement("div");
bg.classList.add("bg");

const pc = document.createElement("div");
pc.classList.add("pc");
pc.appendChild(ol);
pc.appendChild(bg);

class AripdProgress extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(style);
        this.shadowRoot.appendChild(pb);
        this.shadowRoot.appendChild(pc);
    }

    connectedCallback() {
        window.onscroll = () => {
            let scrollTop = window.scrollY;
            let docHeight = document.body.offsetHeight;
            let winHeight = window.innerHeight;
            let scrollPercent = scrollTop / (docHeight - winHeight);
            let scrollPercentRounded = Math.round(scrollPercent * 100);
            let degrees = scrollPercent * 360;
            bg.style.background = `conic-gradient(#498 ${degrees}deg, #ddd ${degrees}deg)`;
            pb.style.background = `linear-gradient(to right, #498 ${scrollPercentRounded}%, #eee ${scrollPercentRounded}%)`;
        };
    }

    adoptedCallback() {
    }

    disconnectedCallback() {
    }
}

customElements.define('aripd-progress', AripdProgress);